import { datadogRum } from '@datadog/browser-rum';
import * as v from 'valibot';
const ErrorReportingConfig = v.object({
    APPLICATION_ID: v.pipe(v.string(), v.nonEmpty()),
    CLIENT_TOKEN: v.pipe(v.string(), v.nonEmpty()),
    WISP_ENV: v.pipe(v.string(), v.nonEmpty()),
    SERVICE_NAME: v.pipe(v.string(), v.nonEmpty()),
    COMMIT_SHA: v.pipe(v.string(), v.nonEmpty()),
});
function initializeErrorReporting(errorReportingConfig) {
    if (!errorReportingConfig) {
        console.log('No error reporting config found');
        return;
    }
    const result = v.safeParse(ErrorReportingConfig, errorReportingConfig);
    if (!result.success) {
        console.error('Invalid error reporting config:', result.issues);
        return;
    }
    const config = result.output;
    datadogRum.init({
        applicationId: config.APPLICATION_ID,
        clientToken: config.CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: config.SERVICE_NAME,
        env: config.WISP_ENV,
        version: config.COMMIT_SHA,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}
initializeErrorReporting(window['__ERROR_REPORTING_CONFIG']);
